import { FlexColumn, FlexRow, MaterialIcon, useModal } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { HeadingSmall, ParagraphLarge } from 'baseui/typography';
import { useParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { useCamera } from '../../hooks/useCamera';
import { useStyles } from '../../hooks/useStyles';
import { assetState } from '../../storage/assets';
import { multipleDevicesLngLatsState } from '../../storage/devices';
import { currentAssetState } from '../../storage/tracking';
import { getAssetTitle } from '../../utils/assets';
import AssetModal from '../assets/modal/AssetModal';
import { StyledTooltip } from '../ui/StyledTooltip';

export function MultipleDevicesInfo({ onShowEvaluations }: { onShowEvaluations?: () => void }) {
  const { theme, classes, css } = useStyles();
  const { assetId } = useParams();
  const asset = useRecoilValue(assetState(assetId ?? ''));
  const currentState = useRecoilValue(currentAssetState(assetId ?? ''));
  const multipleDevicesLngLats = useRecoilValue(multipleDevicesLngLatsState(assetId ?? ''));
  const { closeModal: closeAssetModal, openModal: openAssetModal, showModal: showAssetModal } = useModal();
  const { zoomTo, fitToLngLats } = useCamera();

  if (!asset) {
    return null;
  }

  return (
    <FlexColumn>
      <FlexColumn gap={theme.sizing.scale100}>
        <FlexRow
          classNames={css({
            alignItems: 'center',
            justifyContent: 'space-between',
          })}
        >
          <FlexRow
            gap={theme.sizing.scale200}
            classNames={classes.centeredStart}
          >
            <HeadingSmall margin={0}>{getAssetTitle(asset)}</HeadingSmall>
            <ParagraphLarge
              margin={0}
              color={theme.colors.contentSecondary}
            >
              ({asset.label})
            </ParagraphLarge>
          </FlexRow>
          <FlexRow gap={theme.sizing.scale200}>
            {onShowEvaluations && (
              <StyledTooltip content="Ver evaluaciones">
                <Button
                  shape="circle"
                  kind="tertiary"
                  size="compact"
                  onClick={onShowEvaluations}
                >
                  <MaterialIcon
                    name="linear_scale"
                    size="mini"
                  />
                </Button>
              </StyledTooltip>
            )}
            {asset && (
              <StyledTooltip content="Información del activo">
                <Button
                  shape="circle"
                  kind="tertiary"
                  size="compact"
                  onClick={openAssetModal}
                >
                  <MaterialIcon
                    name="info"
                    size="mini"
                  />
                </Button>
              </StyledTooltip>
            )}
            {!!multipleDevicesLngLats.length && (
              <StyledTooltip content="Centrar">
                <Button
                  shape="circle"
                  kind="tertiary"
                  size="compact"
                  onClick={() => fitToLngLats(multipleDevicesLngLats)}
                >
                  <MaterialIcon
                    name="center_focus_weak"
                    size="mini"
                  />
                </Button>
              </StyledTooltip>
            )}
            {currentState && (
              <StyledTooltip content="Ubicación actual">
                <Button
                  shape="circle"
                  kind="tertiary"
                  size="compact"
                  onClick={() => zoomTo({ lat: currentState.position_latitude, lng: currentState.position_longitude })}
                >
                  <MaterialIcon
                    name="location_searching"
                    size="mini"
                  />
                </Button>
              </StyledTooltip>
            )}
          </FlexRow>
        </FlexRow>
      </FlexColumn>
      <AssetModal
        onClose={closeAssetModal}
        isOpen={showAssetModal}
        assetId={asset._id}
      />
    </FlexColumn>
  );
}
